export const CANAL_VENTE_C = 'C';
